export const badgesContextualSubTitle = [
    {
        text: 'Use the',
        code: '.badge '
    },
    {
        text: 'utility class to make more badges.'
    }
];

export const pillsContextualSubTitle = [
    {
        text: 'Use the',
        code: ' .rounded-pill'
    },
    {
        text: ' class to make badges more rounded pills on badges.'
    }
];

export const numberBadgeSubTitle = [
    {
        text: 'Use numbers as a badge with the help of ',
        code: '.badge'
    },
    {
        text: ' class.'
    }
];

export const numberPillsSubTitle = [
    {
        text: 'Set rounded pill with number using ',
        code: '.rounded-circle'
    },
    {
        text: ' class.'
    }
];

export const badgeWithIconSubTitle = [
    {
        text: 'Use icons with the help of ',
        code: '.badge '
    },
    {
        text: 'class.'
    }
];

export const roundedPillSubTitle = [
    {
        text: 'Set rounded icons badge with help of ',
        code: '.rounded-pill'
    },
    {
        text: ' class.'
    }
];

export const badgeHeadingSubTitle = [
    {
        text: 'Set the badge with html heading h1 through h6 using ',
        code: ' .badge '
    },
    {
        text: 'class.'
    }
];

export const badgeButtonSubTitle = [
    {
        text: 'Add icons as a badge inside the button with the help of ',
        code: '.btn'
    },
    {
        text: ' class.',
    }
]

export const badgesData = [
    {
        id: 1,
        class: 'primary',
        text: 'Primary'
    },
    {
        id: 2,
        class: 'secondary',
        text: 'Secondary'
    },
    {
        id: 3,
        class: 'success',
        text: 'Success'
    },
    {
        id: 4,
        class: 'info',
        text: 'Info'
    },
    {
        id: 5,
        class: 'warning',
        text: 'Warning'
    },
    {
        id: 6,
        class: 'danger',
        text: 'Danger'
    },
    {
        id: 7,
        class: 'light',
        text: 'Light'
    },
    {
        id: 8,
        class: 'dark',
        text: 'Dark'
    }
];

export const badgeIconData = [
    {
        id: 1,
        color: 'primary',
        iconName: <i className="fa-light fa-dollar-sign" />
    },
    {
        id: 2,
        color: 'secondary',
        iconName: <i className="fa-solid fa-headphones-simple" />
    },
    {
        id: 3,
        color: 'success',
        iconName: <i className="fa-solid fa-link" />
    },
    {
        id: 4,
        color: 'info',
        iconName: <i className="fa-brands fa-github" />
    },
    {
        id: 5,
        color: 'warning',
        iconName: <i className="fa-solid fa-award" />
    },
    {
        id: 6,
        color: 'danger',
        iconName: <i className="fa-solid fa-chart-line" />
    },
    {
        id: 7,
        color: 'light',
        iconName: <i className="fa-regular fa-heart" />
    },
    {
        id: 8,
        color: 'dark',
        iconName: <i className="fa-regular fa-envelope" />
    }
];

export const badgeButtonData = [
    {
        class: 'primary',
        text: 'Messages',
        iconName: <i className="fa-regular fa-envelope" />
    },
    {
        class: 'secondary',
        text: 'notifications',
        iconName: <i className="fa-regular fa-bell" />
    },
    {
        class: 'success',
        text: 'Update available',
        iconName: <i className="fa-solid fa-gear" />
    },
    {
        class: 'info',
        text: 'Playing Now',
        iconName: <i className="fa-solid fa-music" />
    }
];